export default [
  {
    path: "viatic",
    name: "monitoring-viatic",
    redirect: { name: "monitoring-viatic-pending" },
    component: () => import("@/views/monitoring/views/viatic/Viatic.vue"),
    meta: {
      section: 6,
      pageTitle: "Viatic",
      breadcrumb: [
        {
          text: "Pending",
        },
      ],
      tabs: [
        {
          title: "Pending",
          name: "monitoring-viatic-pending",
        },
        {
          title: "Approved",
          name: "monitoring-viatic-approved",
        },
      ],
    },
    children: [
      {
        path: "pending",
        name: "monitoring-viatic-pending",
        component: () =>
          import(
            /* webpackChunkName: "MonitoringViaticPending" */ "@/views/monitoring/views/viatic/components/TabViatic.vue"
          ),
        meta: {
          status_viatic: 1,
          section: 6,
          pageTitle: "Viatic",
          breadcrumb: [
            {
              text: "Pending",
              active: true
            },
          ],
        },
      },
      {
        path: "approved",
        name: "monitoring-viatic-approved",
        component: () =>
          import(
            /* webpackChunkName: "MonitoringViaticApproved" */ "@/views/monitoring/views/viatic/components/TabViatic.vue"
          ),
        meta: {
          status_viatic: 2,
          section: 6,
          pageTitle: "Viatic",
          breadcrumb: [
            {
              text: "Approved",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
